function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.0084 21V22.1667H26.1217C26.32 21.7934 26.4717 21.4084 26.5884 21H27.0084Z",
  fill: "#FCFCFC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.0084 16.3333V17.4999H26.5884C26.4717 17.0916 26.32 16.7066 26.1217 16.3333H27.0084Z",
  fill: "#FCFCFC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.5884 17.4999H23.3334V16.3333H26.1217C26.32 16.7066 26.4717 17.0916 26.5884 17.4999Z",
  fill: "#FCFCFC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3334 21H26.5884C26.4717 21.4084 26.32 21.7934 26.1217 22.1667H23.3334V21Z",
  fill: "#FCFCFC"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M25.34 9.49668C25.4684 9.80001 25.3284 10.1383 25.025 10.2667C24.7334 10.3833 24.3834 10.2433 24.2667 9.95168C23.8117 8.86668 22.7617 8.16668 21.5834 8.16668C22.3417 8.16668 23.065 7.95668 23.6717 7.58334C24.4067 8.00334 25.0017 8.66834 25.34 9.49668Z",
  fill: "#FCFCFC"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3333 24.955V25.8417H22.1666V25.4217C22.575 25.305 22.96 25.1533 23.3333 24.955Z",
  fill: "#FCFCFC"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3333 22.1667V24.955C22.96 25.1534 22.575 25.305 22.1666 25.4217V22.1667H23.3333Z",
  fill: "#FCFCFC"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M22.1666 21H23.3333V22.1667H22.1666V21Z",
  fill: "#FCFCFC"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M22.1666 17.5H23.3333V21H22.1666V17.5Z",
  fill: "#FCFCFC"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M22.1666 16.3333H23.3333V17.4999H22.1666V16.3333Z",
  fill: "#FCFCFC"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3333 13.545V16.3333H22.1666V13.0783C22.575 13.195 22.96 13.3466 23.3333 13.545Z",
  fill: "#FCFCFC"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3333 12.6583V13.545C22.96 13.3467 22.575 13.195 22.1666 13.0783V12.6583H23.3333Z",
  fill: "#FCFCFC"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6666 21H22.1666V22.1667H18.6666V21Z",
  fill: "#FCFCFC"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6666 16.3333H22.1666V17.4999H18.6666V16.3333Z",
  fill: "#FCFCFC"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6667 25.4217V25.8417H17.5V24.955C17.8733 25.1533 18.2583 25.305 18.6667 25.4217Z",
  fill: "#FCFCFC"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6667 22.1667V25.4217C18.2583 25.305 17.8733 25.1534 17.5 24.955V22.1667H18.6667Z",
  fill: "#FCFCFC"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 21H18.6667V22.1667H17.5V21Z",
  fill: "#FCFCFC"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 17.5H18.6667V21H17.5V17.5Z",
  fill: "#FCFCFC"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 16.3333H18.6667V17.4999H17.5V16.3333Z",
  fill: "#FCFCFC"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6667 13.0783V16.3333H17.5V13.545C17.8733 13.3466 18.2583 13.195 18.6667 13.0783Z",
  fill: "#FCFCFC"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6667 12.6583V13.0783C18.2583 13.195 17.8733 13.3467 17.5 13.545V12.6583H18.6667Z",
  fill: "#FCFCFC"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 21V22.1667H14.7117C14.5133 21.7934 14.3617 21.4084 14.245 21H17.5Z",
  fill: "#FCFCFC"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 16.3333V17.4999H14.245C14.3617 17.0916 14.5133 16.7066 14.7117 16.3333H17.5Z",
  fill: "#FCFCFC"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7116 22.1667H13.825V21H14.245C14.3616 21.4084 14.5133 21.7934 14.7116 22.1667Z",
  fill: "#FCFCFC"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7116 16.3333C14.5133 16.7066 14.3616 17.0916 14.245 17.4999H13.825V16.3333H14.7116Z",
  fill: "#FCFCFC"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 25.8417H18.6667V25.4217C19.2267 25.585 19.81 25.6667 20.4167 25.6667C21.0234 25.6667 21.6067 25.585 22.1667 25.4217V25.8417H23.3334V24.955C24.535 24.3484 25.515 23.3684 26.1217 22.1667H27.0084V21H26.5884C26.7517 20.44 26.8334 19.8567 26.8334 19.25C26.8334 18.6434 26.7517 18.06 26.5884 17.5H27.0084V16.3334H26.1217C25.515 15.1317 24.535 14.1517 23.3334 13.545V12.6584H22.1667V13.0784C21.6067 12.915 21.0234 12.8334 20.4167 12.8334C19.81 12.8334 19.2267 12.915 18.6667 13.0784V12.6584H17.5V13.545C16.2984 14.1517 15.3184 15.1317 14.7117 16.3334H13.825V17.5H14.245C14.0817 18.06 14 18.6434 14 19.25C14 19.8567 14.0817 20.44 14.245 21H13.825V22.1667H14.7117C15.3184 23.3684 16.2984 24.3484 17.5 24.955V25.8417ZM20.4167 26.8334C16.24 26.8334 12.8334 23.4384 12.8334 19.25C12.8334 15.0734 16.24 11.6667 20.4167 11.6667C24.5934 11.6667 28 15.0734 28 19.25C28 23.4384 24.5934 26.8334 20.4167 26.8334Z",
  fill: "#FCFCFC"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0834 5.83334C10.115 5.83334 9.33337 5.05168 9.33337 4.08334C9.33337 3.12668 10.115 2.33334 11.0834 2.33334C12.0517 2.33334 12.8334 3.12668 12.8334 4.08334C12.8334 5.05168 12.0517 5.83334 11.0834 5.83334ZM11.0834 3.50001C10.7684 3.50001 10.5 3.76834 10.5 4.08334C10.5 4.41001 10.7684 4.66668 11.0834 4.66668C11.3984 4.66668 11.6667 4.41001 11.6667 4.08334C11.6667 3.76834 11.3984 3.50001 11.0834 3.50001Z",
  fill: "#FCFCFC"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8334 11.0833C12.8334 12.0517 12.0517 12.8333 11.0834 12.8333C10.115 12.8333 9.33337 12.0517 9.33337 11.0833C9.33337 10.1267 10.115 9.33334 11.0834 9.33334C12.0517 9.33334 12.8334 10.1267 12.8334 11.0833ZM10.5 11.0833C10.5 11.41 10.7684 11.6667 11.0834 11.6667C11.3984 11.6667 11.6667 11.41 11.6667 11.0833C11.6667 10.7683 11.3984 10.5 11.0834 10.5C10.7684 10.5 10.5 10.7683 10.5 11.0833Z",
  fill: "#FCFCFC"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M9.33337 18.0833C9.33337 17.1266 10.115 16.3333 11.0834 16.3333C11.41 16.3333 11.6667 16.6016 11.6667 16.9166C11.6667 17.2433 11.41 17.4999 11.0834 17.4999C10.7684 17.4999 10.5 17.7683 10.5 18.0833C10.5 18.4099 10.7684 18.6666 11.0834 18.6666C11.41 18.6666 11.6667 18.9349 11.6667 19.2499C11.6667 19.5766 11.41 19.8333 11.0834 19.8333C10.115 19.8333 9.33337 19.0516 9.33337 18.0833Z",
  fill: "#FCFCFC"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M5.25 5.83334C4.28167 5.83334 3.5 5.05168 3.5 4.08334C3.5 3.12668 4.28167 2.33334 5.25 2.33334C6.21833 2.33334 7 3.12668 7 4.08334C7 5.05168 6.21833 5.83334 5.25 5.83334ZM5.25 3.50001C4.92333 3.50001 4.66667 3.76834 4.66667 4.08334C4.66667 4.41001 4.92333 4.66668 5.25 4.66668C5.57667 4.66668 5.83333 4.41001 5.83333 4.08334C5.83333 3.76834 5.57667 3.50001 5.25 3.50001Z",
  fill: "#FCFCFC"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 11.0833C3.5 10.1267 4.28167 9.33334 5.25 9.33334C6.21833 9.33334 7 10.1267 7 11.0833C7 12.0517 6.21833 12.8333 5.25 12.8333C4.28167 12.8333 3.5 12.0517 3.5 11.0833ZM4.66667 11.0833C4.66667 11.41 4.92333 11.6667 5.25 11.6667C5.57667 11.6667 5.83333 11.41 5.83333 11.0833C5.83333 10.7683 5.57667 10.5 5.25 10.5C4.92333 10.5 4.66667 10.7683 4.66667 11.0833Z",
  fill: "#FCFCFC"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M5.25 17.4999C4.92333 17.4999 4.66667 17.7683 4.66667 18.0833C4.66667 18.4099 4.92333 18.6666 5.25 18.6666C5.57667 18.6666 5.83333 18.4099 5.83333 18.0833C5.83333 17.7683 5.57667 17.4999 5.25 17.4999ZM7 18.0833C7 19.0516 6.21833 19.8333 5.25 19.8333C4.28167 19.8333 3.5 19.0516 3.5 18.0833C3.5 17.1266 4.28167 16.3333 5.25 16.3333C6.21833 16.3333 7 17.1266 7 18.0833Z",
  fill: "#FCFCFC"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M4.08333 7.00002H21.5833C22.3417 7.00002 23.065 7.21002 23.6717 7.58335C23.065 7.95668 22.3417 8.16668 21.5833 8.16668H4.08333C4.05999 8.16668 4.03666 8.16668 4.01333 8.16668C3.27833 8.15502 2.59 7.94502 1.995 7.58335C2.61333 7.19835 3.33666 7.00002 4.08333 7.00002Z",
  fill: "#FCFCFC"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0833 14C11.41 14 11.6667 14.2684 11.6667 14.5834C11.6667 14.91 11.41 15.1667 11.0833 15.1667H4.08333C4.05999 15.1667 4.03666 15.1667 4.01333 15.1667C3.27833 15.155 2.59 14.945 1.995 14.5834C2.61333 14.1984 3.33666 14 4.08333 14H11.0833Z",
  fill: "#FCFCFC"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5 4.08333C24.5 2.47333 23.1933 1.16667 21.5833 1.16667H4.08333C2.47333 1.16667 1.16667 2.47333 1.16667 4.08333C1.16667 5.69333 2.47333 7 4.08333 7C3.33667 7 2.61333 7.19833 1.995 7.58333C0.805 6.87167 0 5.57667 0 4.08333C0 1.83167 1.83167 0 4.08333 0H21.5833C23.835 0 25.6667 1.83167 25.6667 4.08333C25.6667 5.57667 24.8617 6.87167 23.6717 7.58333C23.065 7.21 22.3417 7 21.5833 7C23.1933 7 24.5 5.69333 24.5 4.08333Z",
  fill: "#FCFCFC"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M1.995 14.5833C0.805 13.8717 0 12.5767 0 11.0833C0 9.99834 0.42 8.97168 1.20167 8.20168C1.44667 7.95668 1.70333 7.75834 1.995 7.58334C2.59 7.94501 3.27833 8.15501 4.01333 8.16668C3.255 8.19001 2.56667 8.48168 2.01833 9.03001C1.47 9.57834 1.16667 10.3133 1.16667 11.0833C1.16667 12.6933 2.47333 14 4.08333 14C3.33667 14 2.61333 14.1983 1.995 14.5833Z",
  fill: "#FCFCFC"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M4.08333 22.1667C1.83167 22.1667 0 20.335 0 18.0834C0 16.9984 0.42 15.9717 1.20167 15.2017C1.44667 14.9567 1.70333 14.7584 1.995 14.5834C2.59 14.945 3.27833 15.155 4.01333 15.1667C3.255 15.19 2.56667 15.4817 2.01833 16.03C1.47 16.5784 1.16667 17.3134 1.16667 18.0834C1.16667 19.6934 2.47333 21 4.08333 21H9.91667C10.2433 21 10.5 21.2684 10.5 21.5834C10.5 21.91 10.2433 22.1667 9.91667 22.1667H4.08333Z",
  fill: "#FCFCFC"
});

function SvgIconSelectRegions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectRegions);
export default __webpack_public_path__ + "static/media/icon-select-regions.8c4ac98a.svg";
export { ForwardRef as ReactComponent };